import { useEffect } from "react";
import useMe from "../../hooks/useMe";
import { useAuthStore } from "../../store";
import { setAnalyticsUser } from "../../analytics";

export default function AnalyticsUserSync() {
    const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

    const { meData, meFetching } = useMe(isLoggedIn);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        if (meFetching) {
            return;
        }

        if (!meData?.user) {
            return;
        }

        setAnalyticsUser(
            meData.user.id,
            meData.user.type
        );
    }, [
        isLoggedIn,
        meFetching,
        meData?.user.id,
        meData?.user.type,
    ]);

    return null;
}